import type { SVGProps } from 'react';

const SvgAnnotationUndo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M13 6H6.41L7.7 4.71a.996.996 0 0 0 0-1.41.996.996 0 0 0-1.41-.01l-3 3a.996.996 0 0 0 0 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L6.42 8h6.59c3.03 0 5.5 2.47 5.5 5.5s-2.47 5.5-5.5 5.5H5c-.55 0-1 .45-1 1s.45 1 1 1h8c4.14 0 7.5-3.36 7.5-7.5S17.14 6 13 6"
    />
  </svg>
);
export default SvgAnnotationUndo;
